import {DetailField, TableValueType} from "../../shared";
import {Empresa, EmpresaTableColumn, EmpresaTableSources} from "../models";
import {Rol} from "../../core";
import {EmpresaTableAction} from "../enums";

export const EMPRESA_DETAIL_DEFAULT_FIELDS: DetailField[] = [
  { name: 'empresaRazonSocial', label: 'Razón social' },
  { name: 'tipoSocialDescripcion', label: 'Tipo social' },
  { name: 'empresaPersonaCi', label: 'CI' },
  { name: 'empresaRut', label: 'RUT' }
];


export const EMPRESA_TABLE_COLUMNS_DEFAULT: EmpresaTableColumn[] = [
  {
    type: TableValueType.LITERAL,
    name: 'empresaRazonSocial',
    label: 'Razón Social',
    sort: true,
    filter: true
  },
  {
    type: TableValueType.LITERAL,
    name: 'tipoSocialDescripcion',
    label: 'Tipo Social',
    sort: true,
    filter: true
  },
  {
    type: TableValueType.LITERAL,
    name: 'empresaPersonaCi',
    label: 'CI',
    sort: true,
    filter: true,
  },
  {
    type: TableValueType.LITERAL,
    name: 'empresaRut',
    label: 'RUT',
    sort: true,
    filter: true,
  },
  {
    type: TableValueType.ACTION,
    name: EmpresaTableAction.VER,
    label: 'Info',
    sort: false,
    filter: false,
    actionFormat: _ => ({
      value: EmpresaTableAction.VER,
      text: 'Ver detalles',
      icon: 'clipboard-list'
    })
  },
  {
    type: TableValueType.ACTION,
    name: 'MenuAction',
    label: '',
    sort: false,
    filter: false,
    actionFormat: _ => ({
      value: null,
      text: '',
      icon: 'ellipsis-v'
    }),
    actions: [
      {
        type: TableValueType.ACTION,
        name: EmpresaTableAction.MODIFICAR,
        label: '',
        sort: false,
        filter: false,
        actionFormat: (e: Empresa, sources: EmpresaTableSources) => {
          if (sources.rolId !== Rol.USUARIO_LIBRE){
            return {
              value: EmpresaTableAction.MODIFICAR,
              text: 'Modificar',
              icon: 'edit'
            };
          }
          return null;
        }
      },
    ]
  },
  // {
  //   type: TableValueType.LIST,
  //   name: 'contactos.email',
  //   label: 'Contactos',
  //   sort: true,
  //   filter: true
  // },
];
